import request from '@/utils/request';
import { calculateParams } from '@/utils/calculations';

/* eslint-disable */
const actions = {
  async getBanners({ commit, getters, state }, params = {}) {
    const channel = params.channel || 'eshop';
    commit('beginRequest', channel);
    const requestId = state.requestId;
    try {
      const newParams = calculateParams(getters['getPaginationParams'], params);

      commit('setPaginationParams', newParams);

      const { data } = await request.get('/banners', {
        params: { ...newParams, channel },
      });

      if (state.requestId !== requestId) return;

      if (data.error) {
        throw Error('Server-side validation failed');
      }

      commit('setData', data.banners);

      commit('updateIsLoading', { isLoading: false });
    } catch (err) {
      if (state.requestId !== requestId) return;
      console.log(err);
      commit('updateIsLoading', { isLoading: false });

      throw err;
    }
  },
};

export default actions;
